//NOT USED - refer to helpers/date-helpers.js

import VueMoment from 'vue-moment/dist/vue-moment.js'
import Vue from 'vue'
if (!Vue.moment) {
    Vue.use(VueMoment)
  }
export default {
    formatDate(dt) {
        var duration = Vue.moment.duration(Vue.moment(Date.now()).diff(Vue.moment(dt)))
        if (duration.years() > 0) return Vue.moment(dt).format('MMM DD, YYYY')
        if (duration.months() > 0) return Vue.moment(dt).format('MMM DD')
        if (duration.days() > 0) {
            var txt = duration.days()==1?'day ago':'days ago'
            return `${duration.days()} ${txt}`
        }
        if (duration.hours() > 0) {
            var txt = duration.hours()==1?'hour ago':'hours ago'
            return `${duration.hours()} ${txt}`
        }
        if (duration.minutes() > 0) {
            var txt = duration.minutes()==1?'minute ago':'minutes ago'
            return `${duration.minutes()} ${txt}`
        }
        return 'Just now'
    }
}
